const fonts = {
  heading: 'var(--font-poppins)',
  body: 'var(--font-poppins)',
}

export default fonts
